const appConfig = {
    SERVER_URL: process.env.REACT_APP_GUTEGLASSAPI_DOMAIN,
    CALLBACK_URL: process.env.REACT_APP_CALLBACK_URL
}

export default appConfig
